<template>
  <div id="main">
    <carousel :pageData="pageData"></carousel>
    <tab :type="1" :pageData="pageData"></tab>
    <tab :type="2" :pageData="pageData"></tab>
    <!-- 精选课程以上banner -->
    <div class="banner" v-if="pageData.ad_data">
      <a
        v-if="pageData.ad_data.length > 0"
        :href="pageData.ad_data[0].url"
        :style="{ backgroundImage: 'url(' + pageData.ad_data[0].picture + ')' }"
      ></a>
    </div>
    <tab-class :pageData="pageData"></tab-class>
    <!-- <TabClass :pageData="pageData"></TabClass> -->
    <!-- 友情链接课程以上banner -->
    <div class="banner" v-if="pageData.cs_data">
      <a
        v-if="pageData.cs_data.length > 0"
        :href="pageData.cs_data[0].url"
        :style="{ backgroundImage: 'url(' + pageData.cs_data[0].image + ')' }"
      ></a>
    </div>
    <div class="links">
      <div class="links-title">
        <i class="iconfont icon-lianjie"></i>友情链接
        <i class="el-icon-arrow-right"></i>
      </div>
      <div class="links-list">
        <div class="links-box" v-for="(item, index) in pageData.link_data" :key="index">
          <div class="links-item">
            <a
              target="_blank"
              :href="item.url"
              :style="{ backgroundImage: 'url(' + item.logo + ')' }"
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from "./Carousel.vue";
import Tab from "./Tab.vue";
import TabClass from "./TabClass.vue";

export default {
  name: "Main",
  components: {
    Carousel,
    Tab,
    TabClass
  },
  props: {
    pageData: Object
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss">
@import "./../../../assets/iconfont/iconfont.css";
@import "./../../../assets/iconfontNew/iconfont.css";
.banner {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.11);
  margin-bottom: 20px;
  a {
    height: 100%;
    width: 100%;
    display: block;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50%;
    position: relative;
  }
}
.links {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  background-color: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.11);
  border-radius: 2px;
  margin-bottom: 20px;
  .links-title {
    font-size: 20px;
    font-weight: 500;
    line-height: 54px;
    color: #000000;
    border-bottom: 1px solid #f5f5f5;
    box-sizing: border-box;
    padding-left: 25px;
    .iconfont {
      font-size: 20px;
      margin-right: 10px;
    }
    .el-icon-arrow-right {
      margin-left: 12px;
    }
  }
  .links-list {
    width: 1170px;
    height: auto;
    margin: 0 auto;
    padding: 20px 17px;
    position: relative;
    .links-box {
      width: 130px;
      float: left;
      margin: 5px 0;
      .links-item {
        width: 122px;
        height: 52px;
        box-sizing: border-box;
        border: 1px solid #f5f5f5;
        margin: 0 auto;
        a {
          height: 100%;
          width: 100%;
          display: block;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: 50%;
          position: relative;
        }
      }
    }
  }
  .links-list::after,
  .links-list::before {
    display: table;
    content: "";
  }
  .links-list::after {
    clear: both;
  }
}
</style>
